export const ReservedProperties = ["AAAAAAAA", "AAAA0000"];
export const PropertyStatus = {
  ACTIVE: "Active",
  BLOCKED: "Blocked",
  DISBANDED: "Disbanded",
  INACTIVE: "Inactive",
};

export const BLOCKED_PROPERTY_STATUSES = [
  PropertyStatus.BLOCKED,
  PropertyStatus.DISBANDED,
  PropertyStatus.INACTIVE,
];
